import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';

import IconButton from 'components/common/IconButton';
import Tooltip from 'components/common/Tooltip';
import IconClipRotated from 'components/icons/IconClipRotated';
import CMNSelectionDialog from 'components/workflow/CMNSelectionDialog';

const styles = theme => ({
  button: {
    width: 36,
    height: 36,
    marginTop: 6,
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
    },
  },
  buttonSelected: {
    color: theme.palette.primary[500],
  },
  iconClipRotated: {
    width: 18,
    height: 19,
  },
});

class ProductClaimCMNAMBField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false,
    };

    this.onButtonClick = this.onButtonClick.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
  }

  onButtonClick() {
    this.setState({ dialogOpen: true });
  }

  onDialogClose() {
    this.setState({ dialogOpen: false });
  }

  render() {
    const { input, disabled, onPrintEditPreviewButtonClick, classes } = this.props;
    const { dialogOpen } = this.state;
    const button = (
      <IconButton
        className={classNames(classes.button, {
          [classes.buttonSelected]: input.value,
        })}
        onClick={this.onButtonClick}
        {...!disabled ? {
          tooltipContent: input.value || 'CMN/AMB',
        } : {}}
        disabled={disabled !== null}
      >
        <IconClipRotated className={classes.iconClipRotated} />
      </IconButton>
    );
    return (
      <Fragment>
        {disabled ? (
          <Tooltip
            className={classes.tooltip}
            content={disabled === 'save' ? 'Save Order to Enable Attachment'
              : 'File Already Attached in Other Line'}
            placement="top"
            color="dark"
            disableGutters
          >
            {button}
          </Tooltip>
        ) : button}
        <CMNSelectionDialog
          open={dialogOpen}
          onClose={this.onDialogClose}
          form={`${input.name}-CMNSelection`}
          initialValues={{
            'CMN/AMB': input.value,
          }}
          onPrintEditPreviewButtonClick={onPrintEditPreviewButtonClick}
          onClear={() => {
            input.onChange(null);
          }}
        />
      </Fragment>
    );
  }
}

ProductClaimCMNAMBField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
  }).isRequired,
  disabled: PropTypes.string,
  onPrintEditPreviewButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    button: PropTypes.string.isRequired,
    iconClipRotated: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimCMNAMBField.defaultProps = {
  disabled: null,
  onPrintEditPreviewButtonClick: () => {},
};

export default withStyles(styles)(ProductClaimCMNAMBField);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimCMNAMBField.js